const users = {
    userList: [],
    userDDL: [],
    loadingUsers: true,
    selectedRoleUsers: {},
    currentUsersForRole: [],
    usersEdit: [],
    paginatedUsersList: [],
    processDetailsAndRoles: {}
};

export default users;
